import axios from 'axios';

export default {
  fetchOrganizationalUnitList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/organizationalUnit', {
      params: paginationParams,
    })
      .then((organizationalUnits) => {
        commit('setData', organizationalUnits);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteOrganizationalUnit(_, organizationalUnit) {
    return axios.delete(`/organizationalUnit/${organizationalUnit.id}`);
  },
};
